import React from 'react';
import PropTypes from 'prop-types';
import SharedScoreCell from '../../../components/cell/shared/ScoreCell';
import { CELL_TYPE } from '../../../constants/shared/CellConstants';
import { MEASURE, MEASURES_WITH_PERCENTAGE } from '../../../constants/shared/MeasuresConstants';
import ActivitiesSection from '../../activities/ActivitiesSection';
import { generateReactKey } from '../../../utils/shared/commonUtils';
import './SupportBlockGroups.scss';

const { TRC } = MEASURE;

const SupportBlockGroups = ({ groups, onActivityClickHandler }) =>
    groups.map(({ name, description, descriptionExtra, activities, groupResults }) => (
        <section key={generateReactKey(name)} className="group-item">
            <h3 className="group-title">{name}</h3>
            <div className="d-flex font-medium">
                <div className="col-md-8 row align-content-start">
                    <p className="text-justify">{description}</p>
                    {descriptionExtra && (
                        <p className="description-extra-wrap">
                            <i className="ladder-icon" />
                            {descriptionExtra}
                        </p>
                    )}
                    <ActivitiesSection
                        activities={activities}
                        classNames="col-12 row"
                        countInRow={1}
                        onClickHandler={onActivityClickHandler}
                    />
                </div>
                <div className="group-results-wrap">
                    {groupResults.map(
                        (
                            {
                                mark: { measure, isCellDisabled, hasLicense, status },
                                language,
                                skillName,
                                skillAbbr,
                            },
                            i,
                        ) => (
                            <div key={generateReactKey(i)} className="result-card">
                                <SharedScoreCell
                                    cellType={CELL_TYPE.BENCHMARK}
                                    statusForMeasureYearPeriod={status}
                                    measure={measure}
                                    hasLicense={hasLicense}
                                    isCellDisabled={isCellDisabled}
                                    measuresNotCompleted={[TRC]}
                                    measuresWithPercentage={MEASURES_WITH_PERCENTAGE}
                                    gatingMeasureCellType={CELL_TYPE.BENCHMARK_GATING_MEASURE}
                                    optionalCellData={{ classNames: 'without-hover' }}
                                />
                                <div>
                                    <p className="result-lang">{language}</p>
                                    <p className="result-skill">
                                        {skillName}&nbsp;
                                        <span className="result-skill-abbr">{skillAbbr}</span>
                                    </p>
                                </div>
                            </div>
                        ),
                    )}
                </div>
            </div>
        </section>
    ));

SupportBlockGroups.defaultProps = {
    groups: [],
    onActivityClickHandler: () => {},
};

SupportBlockGroups.propTypes = {
    groups: PropTypes.array,
    onActivityClickHandler: PropTypes.func,
};

export default SupportBlockGroups;
